import { toast } from 'sonner';
import { Building2, CalendarPlus, Unlink, Smartphone, KeyRound } from 'lucide-react';
import { extendEnterprise, resetKritis, fill } from '../lib/license';

const untilMs = (u) => Date.UTC(+u.slice(0, 4), +u.slice(4, 6) - 1, +u.slice(6, 8), 23, 59, 59);

function status(c) {
  if (c.revoked) return 'revoked';
  const left = Math.ceil((untilMs(c.until) - Date.now()) / 864e5);
  return left < 0 ? 'expired' : left <= 30 ? 'soon' : 'ok';
}

export default function EnterpriseOverview({ t, codes, onChanged, onRelease }) {
  const ents = codes.filter((c) => c.pack === 'ENT').sort((a, b) => a.until.localeCompare(b.until));
  if (!ents.length) return null;
  const extend = async (c) => {
    if (!window.confirm(fill(t.entExtendConfirm, { company: c.company }))) return;
    try { const r = await extendEnterprise(c.code, 365); toast.success(fill(t.entExtended, { date: new Date(untilMs(r.until)).toLocaleDateString(t.locale) })); onChanged(); } catch (e) { toast.error(e.message === 'owner' ? t.ownerExpired : t.licOffline); }
  };
  const resetPw = async (c) => {
    if (!window.confirm(fill(t.krResetAsk, { company: c.company }))) return;
    try { await resetKritis(c.code); toast.success(t.krResetDone); onChanged(); } catch (e) { toast.error(e.message === 'owner' ? t.ownerExpired : t.licOffline); }
  };
  return (
    <div className="ent-ov" data-testid="enterprise-overview">
      <b><Building2 size={14} /> {t.entOverview}</b>
      {ents.map((c, i) => {
        const st = status(c);
        const left = Math.ceil((untilMs(c.until) - Date.now()) / 864e5);
        const used = (c.devices || []).length;
        return (
          <div key={c.code} className={`ent-card ${st}`} data-testid={`ent-card-${i}`}>
            <div className="ent-card-head">
              <strong data-testid={`ent-card-company-${i}`}>{c.company}</strong>
              <span className={`ent-badge ${st}`} data-testid={`ent-card-status-${i}`}>{t['entSt_' + st]}</span>
            </div>
            <div className="ent-meter" title={`${used}/${c.seats}`}><i style={{ width: `${Math.min(100, (used / c.seats) * 100)}%` }} /></div>
            <div className="ent-card-meta">
              <span data-testid={`ent-card-seats-${i}`}><Smartphone size={12} /> {used}/{c.seats} {t.entDevices}</span>
              <span data-testid={`ent-card-until-${i}`}>{t.colUntil} {new Date(untilMs(c.until)).toLocaleDateString(t.locale)} {st !== 'expired' && `(${fill(t.entDaysLeft, { days: left })})`}</span>
            </div>
            {used > 0 && (
              <div className="ent-card-devs">
                {c.devices.map((d) => (
                  <span key={d.device_id} className="mono">{d.device_id}
                    <button className="icon-btn" aria-label={t.entRelease} data-testid={`ent-card-release-${d.device_id}`} onClick={() => onRelease(c.code, d.device_id)}><Unlink size={11} /></button>
                  </span>
                ))}
              </div>
            )}
            <button className="btn btn-proj btn-sm" data-testid={`ent-card-extend-${i}`} onClick={() => extend(c)}><CalendarPlus size={14} /> {t.entExtend}</button>
            {(c.policy?.kritis || c.kritis_admin) && <small className="muted" data-testid={`ent-card-kritis-${i}`}>🛡️ {[c.policy?.kritis && t.krOn, c.kritis_admin && t.krAdminSet].filter(Boolean).join(' · ')}</small>}
            {c.kritis_admin && <button className="btn btn-outline btn-sm" data-testid={`ent-card-kritis-reset-${i}`} onClick={() => resetPw(c)}><KeyRound size={14} /> {t.krReset}</button>}
          </div>
        );
      })}
    </div>
  );
}
